import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { _dataProvider } from '../dataProvider/DataProvider';

export interface IGroup {
  groupId: number;
  name: string;
  [key: string]: any;
}

interface IUseUserGroupsReturn {
  groupList: IGroup[];
  filteredGroups: IGroup[];
  txt: string;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

/**
 * Custom hook for fetching and filtering user groups
 * Extracts common logic used by PromptPickGroup and PromptPickShareTarget
 */
export const useUserGroups = (): IUseUserGroupsReturn => {
  const [groupList, setGroups] = useState<IGroup[]>([]);
  const [txt, setTxt] = useState('Loading...');
  const [searchQuery, setSearchQuery] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    _dataProvider.getUserGroups().then((groups: any) => {
      if (!groups) {
        setTxt('Server error, check network connection, and try again');
        return;
      }
      if (groups.length === 0) {
        setTxt(t('NoGroup'));
      } else {
        const standardizedGroups: IGroup[] = groups.map((group: any) => ({
          ...group,
          name: group.name || group.Name || ''
        }));
        setGroups(standardizedGroups);
      }
    });
  }, [t]);

  const filteredGroups = useMemo(
    () =>
      groupList.filter((item: IGroup) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    [groupList, searchQuery]
  );

  return {
    groupList,
    filteredGroups,
    txt,
    searchQuery,
    setSearchQuery
  };
};

